import { NgModule } from "@angular/core";
import { OutsetaTicketPopupComponent } from "./outseta-ticket-popup.component";

@NgModule({
  declarations: [OutsetaTicketPopupComponent],
  exports: [OutsetaTicketPopupComponent]
})
export class OutsetaTicketPopupModule {}